import { useState } from 'react';

const faqs = [
  {
    question: '農業ドローンの購入に補助金は使えますか？',
    answer:
      '自治体や年度によって、農業用ドローン導入に関する補助金・助成金制度が用意されている場合があります。申請条件や補助率は地域や制度により異なりますので、まずはお気軽にご相談ください。',
  },
  {
    question: 'ドローン操縦の資格は必要ですか？',
    answer:
      '農業用ドローンの操縦には資格が必要です。IDS教習所グループでは最短3日で農業ドローン協議会認定の操縦士資格が取得できます。',
  },
  {
    question: '購入後のサポート体制は？',
    answer:
      '3拠点すべてで点検・修理、散布代行サービスを提供しています。DJI農業ドローン、FJD自動操舵、EFIX自動操舵、Farmo水管理システム、すべての製品で購入後も安心してご利用いただけます。',
  },
  {
    question: 'どの地域に対応していますか？',
    answer:
      'IDS佐賀教習所は佐賀県全域・福岡県糸島市・長崎県北部、IDS川副教習所は佐賀県東部・福岡県筑後地域、IDS鹿児島教習所は鹿児島県全域に対応しています。',
  },
  {
    question: '価格や見積もりについて教えてください',
    answer:
      'お客様の圃場状況やご予算に応じた最適なプランをご提案します。無料見積もり実施中です。お気軽にお問い合わせください。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-10">
          <h2 className="text-4xl font-bold text-[#2A6041] mb-4">
            よくあるご質問
          </h2>
          <p className="text-lg text-gray-600">
            お客様からよくいただくご質問をまとめました
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex items-start justify-between gap-4 bg-white hover:bg-gray-50 transition-colors duration-200"
              >
                <div className="flex-1">
                  <span className="text-[#2A6041] font-bold text-lg mr-2">
                    Q{index + 1}:
                  </span>
                  <span className="text-gray-800 font-medium text-base">
                    {faq.question}
                  </span>
                </div>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-[#2A6041] transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
                  <span className="text-[#8B4513] font-bold text-lg mr-2">
                    A{index + 1}:
                  </span>
                  <span className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
